import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'au-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss', '../../../unity/css/em-unity-1.7.1.css'],
  styles: [':host { display: inline }'],
})
export class IconComponent {

  @Input() icon: string | undefined;
  @Input() size: 'extraSmall' | 'small' | 'medium' | 'large' = 'small';
  @Input() tooltipText: string | null = null;
  @Input() tooltipBelow = false;
  @Input() useWarningColor = false;
  @Input() color: string | null = null;

  @Input() innerStyle: string | undefined;
  @Input() innerClass: string | undefined;

  //This forces the au-icon tag to be the exact same size as the svg icon (for some reason it often has 2-4 pixels at the bottom otherwise).
  @HostBinding('class.em-c-icon--xsmall') get _xsmall(): boolean { return this.size === 'extraSmall'; }
  @HostBinding('class.em-c-icon--small') get _small(): boolean { return this.size === 'small'; }
  @HostBinding('class.em-c-icon--medium') get _medium(): boolean { return this.size === 'medium'; }
  @HostBinding('class.em-c-icon--large') get _large(): boolean { return this.size === 'large'; }

  public tooltipIcon = false;

  get sizeFolder() {
    if (this.size === 'medium') return '24/';
    if (this.size === 'large') return '48/';
    return '';
  }
}
